import { Tag } from 'antd';
import htmlStringToReactNodes from '../../helpers/htmlStringToReactNodes';
const PopoverContent = ({
  data: {
    language,
    learningObjectiveHTML,
    spanishLearningObjectiveHTML,
    imageURL,
    entity,
    activitiesCount
  }
}) => {
  const learningObjective = [language?.includes('en') && <div key="en" children={htmlStringToReactNodes(learningObjectiveHTML)} />, language?.includes('es') && <div key="es" className="secondary-learningObjective" children={htmlStringToReactNodes(spanishLearningObjectiveHTML ?? learningObjectiveHTML)} />].filter(Boolean);
  return <ul className="thumbnail-popover-container" data-sentry-component="PopoverContent" data-sentry-source-file="PopoverContent.jsx">
    {imageURL && <li className="data-row">
        <img src={imageURL} alt={entity} width={60} height={45} />
      </li>}
    <li className="data-row">
      {entity && <Tag color="purple">{entity}</Tag>}
      {activitiesCount && <span className="description">{activitiesCount} tasks </span>}
    </li>
    {language && <li className="data-row">
        <span className="label">Languages: </span>
        <span className="description">{language.replace('_', ', ').toUpperCase()}</span>
      </li>}
   
    {(learningObjectiveHTML || spanishLearningObjectiveHTML) && <li className="data-row">
        <span className="label">Learning Objective: </span>
        <div className="description">
          {learningObjective}
        </div>
      </li>}
  </ul>;
};
export default PopoverContent;